import React from "react";
import Icon from "components/AppIcon";

const HiddenValueAssets = ({ data }) => {
  return (
    <section className="bg-white rounded-2xl border border-[rgba(40,59,163,0.10)] shadow-sm p-6 md:p-8 lg:p-10">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "rgba(40,59,163,0.08)" }}>
          <Icon name="Gem" size={22} color="var(--color-primary)" strokeWidth={2} />
        </div>
        <div>
          <p className="text-xs font-medium uppercase tracking-widest" style={{ color: "var(--color-accent)", fontFamily: "var(--font-caption)" }}>Section 1</p>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>Your Hidden Value Assets</h2>
        </div>
      </div>
      <p className="text-sm md:text-base mb-6" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-body)" }}>
        After decades of professional experience, you have accumulated assets that most people overlook. Here is what makes you uniquely valuable in today&apos;s economy.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {data?.map((item, idx) => (
          <div key={idx} className="rounded-xl p-4 md:p-5 border" style={{ backgroundColor: "var(--color-surface)", borderColor: "var(--color-border)" }}>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5" style={{ backgroundColor: "rgba(211,172,53,0.12)" }}>
                <Icon name={item?.icon} size={16} color="var(--color-accent)" strokeWidth={2} />
              </div>
              <div className="min-w-0">
                <h3 className="text-sm md:text-base font-semibold mb-1" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)", fontWeight: 700 }}>{item?.title}</h3>
                <p className="text-sm leading-relaxed" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-body)" }}>{item?.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 rounded-xl border-l-4" style={{ backgroundColor: "rgba(40,59,163,0.04)", borderLeftColor: "var(--color-primary)" }}>
        <p className="text-sm md:text-base font-medium" style={{ color: "var(--color-primary)", fontFamily: "var(--font-caption)" }}>
          Why this is economically valuable: Your pattern recognition and domain expertise are precisely what AI tools need human guidance to apply correctly. You are not competing with AI — you are directing it.
        </p>
      </div>
    </section>
  );
};

export default HiddenValueAssets;